import * as React from 'react';
import * as ReactModal from 'react-modal';

import Button from '../components/buttons/Button';
import { IconArrowRight } from '../components/icons';

import Utils from '../common/utils';

interface Props {
	className?: string;
	children?: {};
	isOpen: boolean;
	onRequestClose: () => void;
	userId: number | undefined;
}

const ANIM_DURATION = 300;

class FirstTimeModal extends React.Component<Props> {
	constructor(props: Props) {
		super(props);

		// http://reactcommunity.org/react-modal/accessibility/#app-element
		ReactModal.setAppElement('#root');
	}

	componentDidMount() {
		if (this.props.isOpen) {
			Utils.disableBodyScrolling({allBreakpoints: true});
		}
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.isOpen !== this.props.isOpen) {
			if (this.props.isOpen) {
				Utils.disableBodyScrolling({allBreakpoints: true});
			}
			else {
				Utils.enableBodyScrolling();
			}
		}
	}

	componentWillUnmount() {
		Utils.enableBodyScrolling();
	}

	onAfterClose = () => {
		Utils.enableBodyScrolling();
	}

	render() {
		return (
			<ReactModal
				className="ReactModal_Content section section-main" // Redefine className to remove inline styles
				closeTimeoutMS={ANIM_DURATION}
				contentLabel="TODO"
				isOpen={this.props.isOpen}
				overlayClassName="ReactModal_Overlay" // Redefine className to remove inline styles
				portalClassName="ReactModal" // Redefine className to remove inline styles
				shouldCloseOnEsc={false}
				shouldCloseOnOverlayClick={false}
			>
				<h2 className="mb-3">Welcome</h2>
				<p>
					Tell you friends about Mosaic Life and you could each receive up to $120 if they sign up
				</p>
				<div className="mt-3 d-flex flex-column flex-sm-row justify-content-sm-end">
					<Button className="btn-outline-secondary order-last order-sm-first" onClick={this.props.onRequestClose}>
						Maybe later
					</Button>
					<Button className="btn-secondary ml-sm-3" to={`/user/${this.props.userId}/refer`}>
						Refer someone
						<IconArrowRight className="d-none d-sm-inline-block ml-2" />
					</Button>
				</div>
			</ReactModal>
		);
	}
}

export default FirstTimeModal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/FirstTimeModal.tsx